export default __webpack_public_path__ + "static/media/dbescivil.556dca77.png";